import React, { useContext, useEffect, useState, useRef } from 'react';
import styles from './Maps.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Image, Overlay, Tooltip } from 'react-bootstrap';
import { IpContext, TokenContext, TYPES, ABIContext } from '../../components/Context';
import { Web3Context } from '../../web3/Web3Context';

import IconOpenSeaWhite from '../../assets/icons/icon_opensea_white.png';
import IconTransfer from '../../assets/icons/icon_transfer.png';
import IconMoreOptions from '../../assets/icons/icon-dots.png';

// import maps here
import MapCommon from '../../assets/imgs/maps/map_common.png';
import MapRare from '../../assets/imgs/maps/map_rare.png';
import MapEpic from '../../assets/imgs/maps/map_epic.png';
import MapLegendary from '../../assets/imgs/maps/map_legendary.png';

import { createContract } from '../../services/contractService';
import { SkinAndTicketTransfer } from '../SkinAndTicketTransfer/SkinAndTicketTransfer';
import { allTokenTypes } from '../Skins/utils';
import { PolygonNetworkInfo } from '../../services/networkServices';
import Loader from '../../assets/imgs/loader.gif';

import polygon from '../../assets/icons/polygon-matic-logo-purple-bg-24x24-1x.png';
import openSea from '../../assets/icons/icon-opensea-simple.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import facebookIcon from '../../assets/icons/facebook1.png';
import telegramIcon from '../../assets/icons/telegramIcon.svg';
import twitterIcon from '../../assets/icons/twitterIcon.svg';
import sharelinkIcon from '../../assets/icons/sharelinkIcon.svg';

const withdrawlURL = 'https://www.binance.com/en/support/faq/a2fb25696162460f9379c0ba43c5c622';
const binanceTicketsURL = 'https://www.binance.com/en/nft/shopWindow?tradeType=0&currency=BUSD&orderBy=amount_sort&orderType=1&isBack=1&uid=36804804&order=amount_sort%401';
const openseaMapsURL = 'https://opensea.io/zh-TW/collection/tower-treasury';
const OPENSEA_MUMBAI_ASSETS_URL = process.env.REACT_APP_OPENSEA_URL;
const POLYGON_CHAIN_ID = parseInt(process.env.REACT_APP_POLYGON_CHAIN_ID);

const copyToClipboard = (link) => {
    navigator.clipboard.writeText(link)
}

const Maps = (props) => {

    const { walletConnected } = props;
    const { selectedAccount, networkId, connect, switchNetwork, web3, provider } = useContext(Web3Context);
    const [state, dispatch] = useContext(TokenContext);
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [mapTypeForTransfer, setMapTypeForTransfer] = useState('');
    const [maxTokenCount, setMaxTokenCount] = useState(0);
    const [abiConfig, abiDispatch] = useContext(ABIContext);
    const [t] = useTranslation();
    const [polygonMapsFetched, setPolygonMapsFetched] = useState(false);

    const [popOverMenu, setPopOverMenu] = useState(false);
    const [selectedMap, setSelectedMap] = useState('');
    const [socialShareLinks, setSocialShareLinks] = useState([]);
    const {isInChina} = useContext(IpContext);
    const tooltipTarget = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const [mapImage, setMapImage] = useState(MapCommon);
    const [mapId, setMapId] = useState(0);

    // Fetch deployed inventory contract from polygon network
    const {
        skinAndTicket: {
            polygonTowerInventoryContract,
        },
        polygonProvider,
        polygonDeploymentContext
    } = abiConfig;

    const polygonMapData = {
        totalMapCount: parseInt(state.mapBalance.polygon.mapCommon.count) + parseInt(state.mapBalance.polygon.mapRare.count) + parseInt(state.mapBalance.polygon.mapEpic.count) + parseInt(state.mapBalance.polygon.mapLegendary.count),
        mapCommon: {
            img: MapCommon,
            name: 'Common Map',
            quantity: state.mapBalance.polygon.mapCommon.count,
            tokenId: 22,
        },
        mapRare: {
            img: MapRare,
            name: 'Rare Map',
            quantity: state.mapBalance.polygon.mapRare.count,
            tokenId: 23,
        },
        mapEpic: {
            img: MapEpic,
            name: 'Epic Map',
            quantity: state.mapBalance.polygon.mapEpic.count,
            tokenId: 24,
        },
        mapLegendary: {
            img: MapLegendary,
            name: 'Legendary Map',
            quantity: state.mapBalance.polygon.mapLegendary.count,
            tokenId: 25
        }

    }

    // Social sharing links
    const getSocialLinks = (inventoryAddress, selectedMap) => {
        const allMapsName = Object.keys(polygonMapData).filter((keyName) => keyName !== 'totalMapCount');
        const allMaps = allMapsName.map((map) => {
            return polygonMapData[map]
        });
        let tokenId;
        allMaps.forEach(mapItem => {
            if(mapItem['name'] === selectedMap) {
                tokenId = mapItem['tokenId'];
            }
        });

        return [
            {
                icon: facebookIcon,
                name: 'Facebook',
                link: 'https://www.facebook.com/sharer/sharer.php?u=' +  OPENSEA_MUMBAI_ASSETS_URL + inventoryAddress + "/" + tokenId,
                disabled: isInChina
            },
            {
                icon: telegramIcon,
                name: 'Telegram',
                link: 'https://telegram.me/share/url?url=' + OPENSEA_MUMBAI_ASSETS_URL + inventoryAddress + "/" + tokenId,
                disabled: isInChina
            },
            {
                icon: twitterIcon,
                name: 'Twitter',
                link: 'https://twitter.com/intent/tweet?url=' + OPENSEA_MUMBAI_ASSETS_URL + inventoryAddress + "/" + tokenId,
                disabled: isInChina
            },
            {
                icon: sharelinkIcon,
                name: 'Copy Link',
                copyLink: OPENSEA_MUMBAI_ASSETS_URL + inventoryAddress + "/" + tokenId,
                disabled: isInChina
            },
        ];
    }

    const initializePolygonMapContract = async () => {
        let contract;
        if(networkId === POLYGON_CHAIN_ID) {
            contract = await createContract(polygonDeploymentContext, 'TowerInventory', provider);
        } else {
            contract = await createContract(polygonDeploymentContext, 'TowerInventory', polygonProvider.connection.url);
        }

        if(contract) {
            abiDispatch({
                type: TYPES.INIT_POLYGON_TOWER_INVENTORY_CONTRACT,
                payload: {
                    polygonTowerInventoryAddress: contract.options.address,
                    polygonTowerInventoryContract: contract,
                }
            });
        }
    }

    const fetchPolygonMaps = async () => {
        try {
            // initialize empty arrays that will later store token ids and respective balances
            let polygonMapBalance = {
                mapCommon: {
                    count: 0,
                },
                mapRare: {
                    count: 0,
                },
                mapEpic: {
                    count: 0,
                },
                mapLegendary: {
                    count: 0,
                }
            }

            // because token type for maps is from 22 to 25 in polygon tower inventory contract
            for(let i=22; i<=25; i++) {
                const mapCode = i;
                const mapTokenType = allTokenTypes[mapCode].toString();
                const mapBalance = await polygonTowerInventoryContract.methods.balanceOf(selectedAccount, mapCode).call();
                polygonMapBalance[mapTokenType]['count'] = mapBalance;
            }

            dispatch({
                type: TYPES.SET_MAP_COUNT_MATIC,
                payload: polygonMapBalance,
            });

            setPolygonMapsFetched(true);
        } catch(e) {
            console.log(`Error is: ${e}`);
        }
    }

    const renderMapsLoading = (
        <div className={styles.maps_loading}>
            <div>
                <img className={styles.maps_loading_icon} src={Loader} alt="loading" />
            </div>
            <div className={styles.maps_loading_text}>
                {`We're loading your inventory...`}
            </div>
        </div>
    );

    const renderAdditionalPopUp = (mapImageText) => {
        setPopOverMenu(true);
        setSelectedMap(mapImageText);
    }

    const mapNameToOpenseaURL = (mapImageText) => {
        const allMapsName = Object.keys(polygonMapData).filter((keyName) => keyName !== 'totalMapCount');
        const allMaps = allMapsName.map((map) => {
            return polygonMapData[map]
        });
        let tokenId;
        allMaps.forEach(mapItem => {
            if(mapItem['name'] === mapImageText) {
                tokenId = mapItem['tokenId'];
            }
        });

        const towerInventoryAddress = polygonDeploymentContext.contracts['TowerInventory'].address
        const toUrl = OPENSEA_MUMBAI_ASSETS_URL + towerInventoryAddress + '/' + tokenId;
        return toUrl;
    }

    const navigateToOpenseaListing = (mapImageText) => {
        const toUrl = mapNameToOpenseaURL(mapImageText);
        window.open(toUrl, "_blank");
    }

    const handleTooltip = (mapImageText) => {
        const toUrl = mapNameToOpenseaURL(mapImageText);
        setShowTooltip(true);
        copyToClipboard(toUrl?.toLowerCase())
        setTimeout(() => {
            setShowTooltip(false);
        }, 1500);
        
    }

    const initiateTransfer = async (mapType) => {

        // switch to the polygon network if not yet currently in that network
        let switchNetworkResponse = await switchNetwork(PolygonNetworkInfo);
        if (!switchNetworkResponse) {
            return;
        }

        // based on map type identify the number of tokens available and token type to transfer
        const allMapsName = Object.keys(polygonMapData).filter((keyName) => keyName !== 'totalMapCount');
        const allMaps = allMapsName.map((map) => {
            return polygonMapData[map]
        });

        let maxCount;
        let mType;
        let mapId;
        let image;

        allMaps.forEach((map) => {
            if(map['name'] === mapType) {
                maxCount = map['quantity'];
                mType = map['name'];
                mapId = map['tokenId'];
                image = map['img']
            }
        });

        setShowTransferModal(true);
        setMapTypeForTransfer(mType);
        setMapImage(image);
        setMaxTokenCount(maxCount);
        setMapId(mapId);
    }

    const renderPolygonSingleMap = (mapImageSource, mapImageText, mapCount) => {
        return (
            <div className={styles.polygon_singlemap_maps}>
                <div className={styles.polygon_singlemap_header}>
                    <div className={styles.polygon_singlemap_logos}>
                        <div className={styles.polygon_singlemap_polygon_logo}>
                            <img src={polygon} alt="polygon" />
                        </div>
                        <div className={styles.polygon_singlemap_opensea_logo} onClick={() => navigateToOpenseaListing(mapImageText)}>
                            <img src={openSea} alt="opensea" />
                        </div>
                    </div>
                    
                    <div className={styles.polygon_singlemap_more_options} onClick={() => renderAdditionalPopUp(mapImageText) }>
                        <Image width="18" height="4" src={IconMoreOptions} alt="more-options" />
                    </div>

                    {/* Rendering of overlay */}
                    {(selectedMap === mapImageText) && 
                    <div className={`${styles.polygon_singlemap_options_popup} ${popOverMenu && styles.displayBlock}`}>
                        <span className={styles.closeBtn} onClick={() => setPopOverMenu(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </span>
                        <h3 className={styles.title}>{mapImageText}</h3>
                        <ul className={styles.shareLinks}>
                            {socialShareLinks.map((item, idx) => {
                                if (!item.disabled && !item.copyLink) {
                                    return (
                                        <li key={idx}>
                                            <a href={item.link?.toLowerCase()} target="_blank" rel="noreferrer noopener"><img src={item.icon} alt='' />{item.name}</a>
                                        </li>
                                    );
                                } else if (!item.disabled) {
                                    return (
                                        <li key={idx}>
                                        <span className={styles.copyToClipboard} ref={tooltipTarget} onClick={() => handleTooltip(mapImageText)}><img src={item.icon} alt='' />{item.name}</span>
                                            <Overlay target={tooltipTarget.current}  show={showTooltip} placement="top">
                                            {(props) => (
                                                <Tooltip id="overlay-example" {...props}>
                                                    {'Copied'}
                                                </Tooltip>
                                            )}
                                            </Overlay>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                        <Button className={styles.transferBtn} onClick={() => initiateTransfer(mapImageText)}>
                            <img src={IconTransfer} alt="transfer" />
                            {'Transfer'}
                        </Button>
                    </div>}

                </div>
                <div className={styles.polygon_singlemap_image_with_count}>
                    <div className={styles.polygon_singlemap_image}>
                        <img src={mapImageSource}></img>
                    </div>
                    <div className={styles.polygon_singlemap_amt}>
                        {`x${mapCount}`}
                    </div>
                </div>
                <div className={styles.polygon_singlemap_text}>
                    {mapImageText}
                </div>
            </div>
        );
    }

    const renderPolygonNoMaps = (
        <div className={styles.polygon_no_maps}>
            <div className={styles.polygon_no_maps_text}>
                {t('MAPS_EMPTY_TITLE')}
            </div>
            <div className={styles.polygon_no_maps_description}>
                {t('BUY_ON_OPENSEA')}
            </div>
            <div>
                <Button className={styles.polygon_opensea_btn}>
                    <div className={styles.polygon_btn_icon}>
                        <Image width="16" src={IconOpenSeaWhite} />
                    </div>
                    <a href={openseaMapsURL} target="_blank" rel="noopener noreferrer">
                        <div className={styles.polygon_btn_text}>
                            {t('GO_OPENSEA_BTN')}
                        </div>
                    </a>
                </Button>
            </div>
        </div>
    );

    const renderPolygonMaps = (polygonMapData) => {
        const totalMapCount = polygonMapData['totalMapCount'];
        const allMapsName = Object.keys(polygonMapData).filter((keyName) => keyName !== 'totalMapCount');
        const allMaps = allMapsName.map((map) => {
            return polygonMapData[map]
        });

        return (
            <>
                <div className={styles.polygon_maps_count}>
                    {`Total: ${totalMapCount}`}
                </div>
                {allMaps.map((map) => {
                    return (
                        <div key={map['name']} className={styles.polygon_maps}>
                            { renderPolygonSingleMap(map['img'], map['name'], map['quantity']) }
                        </div>
                    )
                })}
            </>
        );
    }

    useEffect(() => {
        if(window.ethereum && polygonDeploymentContext && polygonProvider) {
            initializePolygonMapContract();
        }
    }, [networkId, polygonDeploymentContext, polygonProvider]);

    useEffect(() => {
        if(selectedAccount && polygonTowerInventoryContract) {
            fetchPolygonMaps();
        }
    }, [polygonTowerInventoryContract, selectedAccount]);

    useEffect(() => {
        // this code block is for sharing to social media links
        if(polygonDeploymentContext?.contracts && selectedMap) {
            let socialLinksResult = getSocialLinks(polygonDeploymentContext.contracts['TowerInventory'].address, selectedMap);
            setSocialShareLinks([...socialLinksResult]);
        }
    }, [polygonDeploymentContext, selectedMap]);

    return (
        <>
            {walletConnected ?
            <div className={styles.maps_items_section}>
                <div className={styles.maps_network_groups}>
                    <div className={`${styles.polygon_network_group} ${styles.polygon_network_background}`}>
                        <div className={styles.polygon_network_content}>
                            {!polygonMapsFetched ?
                                renderMapsLoading : (
                                    polygonMapsFetched && (polygonMapData.totalMapCount > 0) ?
                                        renderPolygonMaps(polygonMapData) :
                                        renderPolygonNoMaps
                                )
                            }
                        </div>
                    </div>
                </div>
            </div> :
            <div className={styles.no_maps_section}>
                <div className={styles.main_text}>{t('CONNECT_WALLET_ACCESS_INVENTORY')}</div>
                <div className={styles.secondary_text}>{t('NO_ITEMS_WITHOUT_CONNECT')}</div>
                <Button variant="cdh-general-blue-dbrown" className={styles.primary_btn} onClick={connect}>{t('CONNECT')}</Button>
            </div>}
            
            { 
                showTransferModal === true 
                    ? <SkinAndTicketTransfer
                        web3={web3}
                        showTransferModal={showTransferModal}
                        setShowTransferModal={setShowTransferModal}
                        switchNetwork={switchNetwork}
                        PolygonNetworkInfo= {PolygonNetworkInfo}
                        maxTokenCount={maxTokenCount}
                        mapTypeForTransfer={mapTypeForTransfer} 
                        mapImage={mapImage} 
                        mapId={mapId}/>
                    : <></>
            }  
        </>
    )
}

export { Maps }
